// extracted by mini-css-extract-plugin
export default {"avatarForm":"AvatarUpload_avatarForm__APD3A","userAvatarInput":"AvatarUpload_userAvatarInput__DGGA-","changeAvatarButton":"AvatarUpload_changeAvatarButton__vbkd8"};